import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Bulk_Fields } from '../../../../constants/fields';
import { ForecastBulkService } from '../../services/forecast-bulk.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { ExportDataService } from '../../../../shared';

import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { CommonService } from '../../shared/services/bulk-maintenance/common.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from '../../shared/services/bulk-maintenance/bulk-maintenance-error-messages';
@Component({
    selector: 'app-bulk-forecast',
    templateUrl: './bulk-forecast.component.html',
    styleUrl: './bulk-forecast.component.scss',
    standalone: false
})
export class BulkForecastComponent implements OnInit {
  isDataLarge: boolean = false;
  showLoader: boolean = false;
  showtable: boolean = false;
  fileToUpload: File = null;
  showPreview: boolean = false;
  successPayload: any = [];
  failedData: any = [];
  uploadedData: any[];
  uploadedColumnNames: string[];
  missingColumns: string[] = [];
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  TABLE_COLUMNS_PASS: any[];
  TABLE_COLUMNS_FAIL: any[];
  dataSourceDetails_fail: MatTableDataSource<unknown>;
  dataSourceDetails_Pass: MatTableDataSource<unknown>;
  TABLE_CONFIG: any = {
    pageSize: 10,
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    FILTER_OPTIONS:{'Message'   : []}
  };
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit',
     Message: 'select'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  passdata: any[] = [];
  faildata: any[] = [];
  submitPayload: any;
  currentForecast: any;
  Filepath: string = 'assets/Forecast_Bulk_Edit_Template.xlsx';
  validTime: boolean = true;
  @Input() isForecastAdmin: boolean = false;
  filteredData: any[] = [];
  activeFilters: { [key: string]: any[] } = {}; 
  private forecastBulkRequiredHeaders = [
      'Update Type',
      'ASK_Global_Id', 'service', 'year', 
      'QNT_Jan' ,'QNT_Feb', 'QNT_Mar', 'QNT_Apr',
      'QNT_May', 'QNT_Jun', 'QNT_Jul', 'QNT_Aug',
      'QNT_Sep', 'QNT_Oct', 'QNT_Nov', 'QNT_Dec',
  ];
  private allBulkHeaders = [
      'Update Type',
      'ASK_Global_Id', 'service', 'year', 
      'QNT_Jan' ,'QNT_Feb', 'QNT_Mar', 'QNT_Apr',
      'QNT_May', 'QNT_Jun', 'QNT_Jul', 'QNT_Aug',
      'QNT_Sep', 'QNT_Oct', 'QNT_Nov', 'QNT_Dec',
      'CY_Rate', 'Unit_Of_Measure', 'I_Flag',
      'LONG_APP_NAME', 'SV_Desc', 'Forecast_Cycle',
      'Service_Owner_Email', 'Service_Owner',
      'Service_Owner_MSID', 'Edit_TOH'
  ]
  constructor(
    private forecastBulkService: ForecastBulkService,
    public toaster: ToastrService,
    private exportService: ExportDataService,
    private sharedAuthService: SharedAuthService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.showLoader = true;
    this.forecastBulkService.fcCurrentForecastYear().subscribe(
      data => {
        this.currentForecast = data;
        this.showLoader = false;
        const currentDate = moment();
        const startDate = moment(data['start_date']);
        const endDate = moment(data['end_date']);
        const adminEndDate = moment(data['Admin_End_Date']);

        if (this.isForecastAdmin) {
          if (currentDate.isAfter(adminEndDate) || currentDate.isBefore(startDate)) {
            this.validTime = false;
          } else {
            this.validTime = true;
          }
        } else {
          if (currentDate.isAfter(endDate) || currentDate.isBefore(startDate)) {
            this.validTime = false;
          } else {
            this.validTime = true;
          }
        }
      },
      error => {
        console.error(error);
        this.showLoader = false;
        this.toaster.error(BULK_MAINTENANCE_ERROR_MESSAGES.FORECAST_BULK.GENERIC_ERROR, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    );
  }


     // Handle filter applied event
     onFilterApplied(event: { columnKey: string, selectedValues: any[] }) {
      // chekk if activeFilters is not empty, if so empty the activeFilters object
      if (Object.keys(this.activeFilters).length != 0) {
        this.activeFilters = {};
      }
      this.activeFilters[event.columnKey] = event.selectedValues;
      this.applyFilters();
    }
  
    // Handle filter cleared event
    onFilterCleared(columnKey: string) {
      delete this.activeFilters[columnKey];
      this.applyFilters();
    }
  
   
    applyFilters() {
      const filtered = this.faildata.filter(row => {
        return Object.keys(this.activeFilters).every(columnKey => {
          if (!this.activeFilters[columnKey] || this.activeFilters[columnKey].length === 0) {
            return true; 
          }  
       
          if (columnKey === 'Message' && row[columnKey]) {
            const rowMessages = row[columnKey]?.split(',').map(message => message.trim()) || [];
            return this.activeFilters[columnKey].some(filter => rowMessages.includes(filter));
          }  
         
          return this.activeFilters[columnKey].includes(row[columnKey]);
        });
      });  
     
      this.dataSourceDetails_fail = new MatTableDataSource(filtered);
    }

  uploadFileEvt(files: FileList) {
    if (files && files.length) {
      this.isDataLarge = false;
      // this.showtable = !this.showtable;
      this.fileToUpload = files.item(0);
       if (!this.commonService.validateFileFormat(this.fileToUpload)) {
        this.showLoader = false;
        this.toaster.error(BULK_MAINTENANCE_ERROR_MESSAGES.FORECAST_BULK.FILE_FORMAT_UNSUPPORTED);
        return;
      }
      this.forecastBulkService.convertCsvToArray(this.fileToUpload)
        .then(data => {
          this.uploadedData = data.excelRows;
          this.uploadedColumnNames = data.headers;
          this.showPreview = true;
        })
        .catch(error => {
          console.error('Error converting CSV:', error);
          this.showPreview = false;
        });
  
      this.successPayload = [];
      this.fileToUpload = null;
    }
  }

  cancelUpload() {
    this.fileToUpload = null;
    this.fileInput.nativeElement.value = '';
    this.showtable = false;
    this.showPreview = false;
    this.missingColumns = [];
    this.isDataLarge = false;
  }
  

  public submitForm(flag) {
    if (flag === true && this.faildata.length > 0) {
      this.exportAppData();
    }
    this.showLoader = true;
    if (!flag) {
      this.showLoader = true;
      this.uploadedColumnNames = this.commonService.modifyHeaders(this.uploadedColumnNames, this.allBulkHeaders);
      this.uploadedData = this.commonService.modifyUploadedData(this.uploadedData, this.uploadedColumnNames);
      this.missingColumns = this.commonService.checkRequiredHeaders(this.uploadedColumnNames, this.forecastBulkRequiredHeaders);

      const configurableTableColumns_pass = Bulk_Fields.Forecast_Table_Columns_Pass;
      const configurableTableColumns_fail = Bulk_Fields.Forecast_Table_Columns_Fail;

      if (this.uploadedData.length > 2000) this.isDataLarge = true;

      if (this.missingColumns.length > 0 || this.isDataLarge) {
        this.showLoader = false;
        this.showtable = false;
        this.showPreview = false;
        this.fileToUpload = null;
        this.fileInput.nativeElement.value = '';
      } else {
        const FileData = this.uploadedData;
        const {totalRecords, duplicateRecords} = this.forecastBulkService.validateRecord(FileData, this.currentForecast); //{ uniqueRecords, duplicateRecords, errorRecords }
        let uniqueRecords = totalRecords && totalRecords.length > 0 ? totalRecords.filter(record => record['Status'] === 'Success') : [];
        let errorRecords = totalRecords && totalRecords.length > 0 ? totalRecords.filter(record => record['Status'] === 'Fail') : [];
        if (uniqueRecords.length > 0) {
          this.forecastBulkService.fcBulkPreview({ uniqueRecords, currentForecast: this.currentForecast['Forecast_Months'], isForecastAdmin: this.isForecastAdmin }).subscribe(
            data => {
              const { totalSuccessRec, totalErrorRec } = data;
              
              this.faildata = [...duplicateRecords, ...errorRecords, ...totalErrorRec];
              this.passdata = totalSuccessRec;
              this.TABLE_COLUMNS_PASS = configurableTableColumns_pass;
              this.TABLE_COLUMNS_FAIL = configurableTableColumns_fail;

              const allErrors = this.faildata.flatMap(row => row['Message']?.split(',').map(error => error.trim()) || []);
              const uniqueErrors = Array.from(new Set(allErrors));
              const finalError = uniqueErrors.map(error => ({ key: error, value: error }));
              this.TABLE_CONFIG.FILTER_OPTIONS['Message'] = finalError;

              this.dataSourceDetails_fail = new MatTableDataSource(this.faildata);
              this.dataSourceDetails_fail.sort = this.sort;
              this.dataSourceDetails_Pass = new MatTableDataSource(this.passdata);

                this.TABLE_CONFIG['TABLE_CLASS'] = 'org-maintenance-tble-container';
                this.TABLE_CONFIG.totalItems = FileData.length > 0 ? FileData.length : 0;
                this.showLoader = false;
                this.showtable = true;
                this.showPreview = false;
              },
              error => {
                console.error(error);
                this.showLoader = false;
                this.toaster.error(BULK_MAINTENANCE_ERROR_MESSAGES.FORECAST_BULK.GENERIC_ERROR, '', {
                  positionClass: 'toast-top-center',
                  timeOut: 1000
                });
              }
            );
        } else {
          this.fileToUpload = null;
          this.fileInput.nativeElement.value = '';
          this.faildata = [...duplicateRecords, ...errorRecords];

          this.passdata = [];
          this.TABLE_COLUMNS_PASS = configurableTableColumns_pass;
          this.TABLE_COLUMNS_FAIL = configurableTableColumns_fail;

          const allErrors = this.faildata.flatMap(row => row['Message']?.split(',').map(error => error.trim()) || []);
          const uniqueErrors = Array.from(new Set(allErrors));
          const finalError = uniqueErrors.map(error => ({ key: error, value: error }));
          this.TABLE_CONFIG.FILTER_OPTIONS['Message'] = finalError;
          
          this.dataSourceDetails_fail = new MatTableDataSource(this.faildata);
          this.dataSourceDetails_fail.sort = this.sort;
          this.dataSourceDetails_Pass = new MatTableDataSource(this.passdata);

          this.TABLE_CONFIG['TABLE_CLASS'] = 'org-maintenance-tble-container';
          this.TABLE_CONFIG.totalItems = FileData.length > 0 ? FileData.length : 0;
          this.showLoader = false;
          this.showtable = true;
          this.showPreview = false;
        }
      }
    } else {
      this.showtable = false;
      this.showPreview = false;
      const payload = {
        User_msid: this.sharedAuthService.getMsid(),
        User_email: sessionStorage.getItem('loggedInUserEmail'),
        Action_Type: 'Infra_Forecast_Edit'
      };
      this.submitPayload = {
        excelValidatedRecords: this.passdata,
        payload: payload
      };
      this.forecastBulkService.fcBulkSubmit(this.submitPayload).subscribe(
        data => {
          this.fileToUpload = null;
          this.fileInput.nativeElement.value = '';
          this.showtable = false;
          this.showLoader = false;

          if (data['error'] == undefined) {
            this.toaster.success(BULK_MAINTENANCE_ERROR_MESSAGES.FORECAST_BULK.SUBMIT_SUCCESS, '', {
              positionClass: 'toast-top-center',
              timeOut: 2000
            });
          }
          if (data['error']) {
            this.showLoader = false;
            this.toaster.error(data['error'], '', { positionClass: 'toast-top-center', timeOut: 2000 });
          }
        },
        error => {
          console.error(error);
          this.showLoader = false;
          this.toaster.error(BULK_MAINTENANCE_ERROR_MESSAGES.FORECAST_BULK.GENERIC_ERROR, '', {
            positionClass: 'toast-top-center',
            timeOut: 1000
          });
        }
      );
    }
  }

  exportAppData() {
    const name = 'Forecast Bulk';
    this.exportService.exportToExcel(name, [this.faildata]);
  }
}
